import { useEffect, useState } from 'react';
import type { TreePanelProps, TreePanelNodeId } from '@scmlatam/web-ui';
import { executeService } from '../services/service';
import type { Config } from '../../results/types/hooks';
import type { UseStepCategoryProps } from '../types/hooks';
import { PermisosReportes, usePermisoReportes } from '../../../../auth/permisosModulos';

const useStepCategory = ({ activeStep }: UseStepCategoryProps) => {
    const canViewCategories = usePermisoReportes('listar-categorias');
    const canViewReports = usePermisoReportes('listar-reportes');
    const canViewCatalog = canViewCategories && canViewReports;
    const [categories, setCategories] = useState<TreePanelProps['items']>([]);

    const [selectedIds, setSelectedIds] = useState<TreePanelNodeId[]>([]);
    const [expandedIds, setExpandedIds] = useState<TreePanelNodeId[]>([]);

    const [loadingCategories, setLoadingCategories] = useState<boolean>(false);

    const initialTreePanel = () => {
        // revisa si existe un query param de reports= si existe asignaselo a selectedIds siguendo 'report-' + id del reporte
        const queryParams = new URLSearchParams(window.location.search);
        const reportsParam = queryParams.get('reports');

        console.log('reportsParam', reportsParam);

        if (reportsParam) {
            const reportIds = reportsParam.split(',').map((id) => `report-${id}`);
            setSelectedIds(reportIds);
        }
    };

    const getData = async () => {
        let configs: Config[] = JSON.parse(localStorage.getItem('config_system') || '[]');

        setLoadingCategories(true);

        const { categories, categoryIds } = await executeService.getCategories({
            setLoading: setLoadingCategories,
            body: {
                columns_select: ['*'],
                where_select: {
                    company_id: parseInt(configs.find((config) => config.key === 'company_id')?.value || '0'),
                },
            },
        });

        const { reports } = await executeService.getReports({
            setLoading: setLoadingCategories,
            body: {
                columns_select: ['*'],
                where_select: {
                    category_id: `$FIND_IN_SET$${categoryIds.join(',')}`,
                },
            },
        });

        setCategories(
            categories.map((category) => ({
                id: `category-${category.id}`,
                label: category.name,
                className: '',
                description: '',
                disabled: false,
                selectable: true,
                children: reports
                    .filter((report) => report.category_id === category.id)
                    .map((report) => ({
                        id: `report-${report.id}`,
                        label: report.name,
                        className: `${report.slug}`,
                        description: report.description,
                        disabled: false,
                        selectable: true,
                    })),
            })),
        );

        initialTreePanel();

        setLoadingCategories(false);
    };

    useEffect(() => {
        if (activeStep === 0 && canViewCatalog) {
            getData();
        }
    }, [activeStep, canViewCatalog]);

    return {
        categories,
        setCategories,
        loadingCategories,
        setLoadingCategories,
        selectedIds,
        setSelectedIds,
        expandedIds,
        setExpandedIds,
        canViewCatalog,
        requiredCatalogPermissions: [...PermisosReportes['listar-categorias'], ...PermisosReportes['listar-reportes']],
    };
};

export { useStepCategory };
